import VendorInvoicesHtml from './templates/vendor-invoices.html';

export function VendorInvoices () {
  return {
    controller: 'VendorInvoicesCtrl',
    restrict: 'E',
    templateUrl: VendorInvoicesHtml,
    scope: {
      vendor: '=',
      invoices: '='
    }
  }
}
